import { useEffect } from 'react';

/**
 * Tint the document canvas (``html`` background). Android edge-to-edge samples
 * it for the bottom system-bar / safe-area color where no element paints, so
 * driving it per view keeps that region dynamic. Restores the prior value when
 * the color changes or the caller unmounts. Pass ``null`` to leave it alone.
 */
export const useCanvasBackground = (color: string | null): void => {
  useEffect(() => {
    if (!color) return undefined;
    // Set both: html is the canvas, but CssBaseline paints body over the
    // edge-to-edge viewport, so body must match to control the system-bar strip.
    const html = document.documentElement;
    const { body } = document;
    const prevHtml = html.style.backgroundColor;
    const prevBody = body.style.backgroundColor;
    html.style.backgroundColor = color;
    body.style.backgroundColor = color;
    return () => {
      html.style.backgroundColor = prevHtml;
      body.style.backgroundColor = prevBody;
    };
  }, [color]);
};
